import React, { memo, useEffect } from "react";
import SelectGroup from "./SelectGroup/SelectGroup.tsx";
import { PolicyFullObject } from "../../types/insurance.ts";
import SectionHeader from "../SectionHeader/SectionHeader.tsx";

interface PolicyFormProps {
  policyData: PolicyFullObject;
  handleChange: (
    e: React.ChangeEvent<HTMLInputElement | HTMLSelectElement>
  ) => void;
  insuranceCompanies: { [key: string]: string };
  policyTypes: { [key: string]: string };
  offices: { [key: string]: string };
  agentOptions: { [key: string]: string };
}

const labelClass =
  "mb-1 ml-1 block text-xs font-medium text-black dark:text-white";

const PolicyFormComponent: React.FC<PolicyFormProps> = ({
  policyData,
  handleChange,
  insuranceCompanies,
  policyTypes,
  offices,
  agentOptions,
}) => {
  useEffect(() => {
    const officeKeys = Object.keys(offices);
    if (officeKeys.length === 1 && policyData.divisionId !== officeKeys[0]) {
      handleChange({
        target: { name: "divisionId", value: officeKeys[0] },
      } as React.ChangeEvent<HTMLSelectElement>);
    }
  }, [offices]);

  useEffect(() => {
    if (!agentOptions) return;
    const agentKeys = Object.keys(agentOptions);
    if (agentKeys.length === 1 && policyData.agentId !== agentKeys[0]) {
      handleChange({
        target: { name: "agentId", value: agentKeys[0] },
      } as React.ChangeEvent<HTMLSelectElement>);
    }
  }, [agentOptions]);

  return (
    <fieldset className="border-stroke dark:border-strokedark shadow-default dark:bg-boxdark rounded-sm border bg-white">
      <SectionHeader title="Информация за полица" />

      <div className="pt-4.5 grid grid-cols-2 gap-3 p-4 lg:grid-cols-4">
        <div>
          <label className={labelClass}>ЗК</label>
          <SelectGroup
            placeholder="Изберете ЗК"
            options={insuranceCompanies}
            value={policyData.insuranceCompanyId}
            onChange={(selectedValue: string) => {
              handleChange({
                target: { name: "insuranceCompanyId", value: selectedValue },
              } as React.ChangeEvent<HTMLSelectElement>);
            }}
          />
        </div>
        <div>
          <label className={labelClass}>Вид полица</label>
          <SelectGroup
            placeholder="ГО"
            options={policyTypes}
            value={policyData.policyTypeId || 5}
            onChange={(selectedValue: string) => {
              handleChange({
                target: { name: "policyTypeId", value: selectedValue },
              } as React.ChangeEvent<HTMLSelectElement>);
            }}
          />
        </div>
        <div>
          <label className={labelClass}>Офис</label>
          <SelectGroup
            placeholder="Изберете Офис"
            options={offices}
            value={policyData.divisionId}
            onChange={(selectedValue: string) => {
              handleChange({
                target: { name: "divisionId", value: selectedValue },
              } as React.ChangeEvent<HTMLSelectElement>);
            }}
          />
        </div>
        {agentOptions && (
          <div>
            <label className={labelClass}>Агент</label>
            <SelectGroup
              placeholder="Изберете агент"
              value={policyData.agentId}
              options={agentOptions}
              onChange={(selectedValue: string) => {
                handleChange({
                  target: { name: "agentId", value: selectedValue },
                } as React.ChangeEvent<HTMLSelectElement>);
              }}
            />
          </div>
        )}
      </div>
    </fieldset>
  );
};

PolicyFormComponent.displayName = "PolicyForm";
const PolicyForm = memo(PolicyFormComponent);
export default PolicyForm;
